import React from 'react'

const React_Coding_Practice_12 = () => {
  return (
    <div>
      <h1>Coding Pratice 12</h1>
    </div>
  )
}

export default React_Coding_Practice_12
